import { fetchApi } from '@/config/axiosSetting.ts';
import { SignInMutationDataType } from '@/modules/Auth/queries/signIn/signInMutation.type.ts';

export const signInMutationFunction = (formData: SignInMutationDataType) => {
  return fetchApi({
    method: 'post',
    url: 'verification/login/create_otp/',
    data: formData,
  });
};
